var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { configureAnchors } from 'react-scrollable-anchor';
import * as Raven from 'raven-js';
import { feathersAuthentication } from './feathers';
import setSocketListeners from './feathers/setSocketListeners';
import { resetWorkspaceMain, setWorkspaceMainUser, setWorkspaceMainUserProfile, setWorkspaceMainUserOrganizationRoles, setWorkspaceMainUserEventRoles, setWorkspaceMainOrganizations, setWorkspaceMainEvents, } from './reducers/workspaceMain/actions';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/index.css';
import Routes from './routes';
import PageLoading from './pages/PageLoading';
import './imports/styles/extend.message.scss';
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.subscribers = {};
        _this.state = {
            isCheckingLogin: true,
            isFetchingData: true,
        };
        _this.handleCurrentToken = _this.handleCurrentToken.bind(_this);
        _this.handleDeleteToken = _this.handleDeleteToken.bind(_this);
        _this.handleSetToken = _this.handleSetToken.bind(_this);
        return _this;
    }
    App.prototype.componentWillMount = function () {
        var _this = this;
        feathersClient.passport.getJWT()
            .then(function (jwt) {
            if (!jwt) {
                return Promise.reject({});
            }
            return _this.handleCurrentToken();
        })
            .then(function () {
            _this.setState({ isCheckingLogin: false });
        })
            .catch(function () {
            _this.setState({ isCheckingLogin: false });
        });
    };
    App.prototype.componentDidMount = function () {
        var _this = this;
        message.config({
            top: 8,
            getContainer: function () { return document.getElementById('root') || document.body; },
        });
        notification.config({
            duration: 0,
            top: 70,
            getContainer: function () { return document.getElementById('root') || document.body; },
        });
        configureAnchors({
            offset: -72,
            scrollDuration: 150,
        });
        window.addEventListener('storage', function (e) {
            if (e.key !== 'crimp-jwt') {
                return;
            }
            if (e.newValue) {
                _this.handleSetToken(e.newValue);
            }
            if (e.newValue === null ||
                e.newValue === undefined) {
                _this.handleDeleteToken();
            }
        });
        feathersClient.on('authenticated', function (authRes) {
            var user = authRes.data;
            _this.subscribeUser(user);
            Raven.setUserContext({ userId: user.id });
        });
        feathersClient.on('logout', function () {
            _this.unsubscribeWorkspaceMain();
            Raven.setUserContext();
        });
        setSocketListeners();
    };
    App.prototype.componentWillReceiveProps = function (nextProps) {
        var workspaceMain = nextProps.workspaceMain;
        if (workspaceMain.user &&
            workspaceMain.organizations &&
            workspaceMain.events) {
            this.setState({ isFetchingData: false });
        }
        else {
            this.setState({ isFetchingData: true });
        }
    };
    App.prototype.handleCurrentToken = function () {
        return this.props.dispatch(feathersAuthentication.authenticate());
    };
    App.prototype.handleDeleteToken = function () {
        return this.props.dispatch(feathersAuthentication.logout());
    };
    App.prototype.handleSetToken = function (jwtToken) {
        console.warn('app.handleSetToken, crimp-application/#3');
        if (this.props.isAuthenticated) {
            return;
        }
        console.warn('  - Calling authentication');
        return this.handleCurrentToken();
    };
    App.prototype.subscribeUser = function (user) {
        var _this = this;
        this.subscribers.user = feathersClient.service('users')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                id: user.id,
                $limit: 1,
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainUser(res));
        }, function (err) { Raven.captureException(err); });
        this.subscribers.userProfiles = feathersClient.service('userProfiles')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                userId: user.id,
                $limit: 1,
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainUserProfile(res));
        }, function (err) { Raven.captureException(err); });
        this.subscribers.userOrganizationRoles = feathersClient.service('userOrganizationRoles')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                userId: user.id,
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainUserOrganizationRoles(res));
            var organizationId = res.data.map(function (e) { return e.organizationId; });
            _this.subscribeOrganizations(user, organizationId);
        }, function (err) { Raven.captureException(err); });
        this.subscribers.userEventRoles = feathersClient.service('userEventRoles')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                userId: user.id,
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainUserEventRoles(res));
            var eventId = res.data.map(function (e) { return e.eventId; });
            _this.subscribeEvents(user, eventId);
        }, function (err) { Raven.captureException(err); });
    };
    App.prototype.subscribeOrganizations = function (user, organizationId) {
        var _this = this;
        if (this.subscribers.organizations) {
            this.subscribers.organizations.unsubscribe();
        }
        var query = {
            query: {
                id: organizationId,
                $sort: { id: 1 },
            },
        };
        if (user.isAdmin) {
            delete query.query.id;
        }
        this.subscribers.organizations = feathersClient.service('organizations')
            .watch({ listStrategy: 'always' })
            .find(query)
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainOrganizations(res));
        }, function (err) { Raven.captureException(err); });
    };
    App.prototype.subscribeEvents = function (user, eventId) {
        var _this = this;
        if (this.subscribers.events) {
            this.subscribers.events.unsubscribe();
        }
        var query = {
            query: {
                id: eventId,
                $sort: { id: 1 },
            },
        };
        if (user.isAdmin) {
            delete query.query.id;
        }
        this.subscribers.events = feathersClient.service('events')
            .watch({ listStrategy: 'always' })
            .find(query)
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceMainEvents(res));
        }, function (err) { Raven.captureException(err); });
    };
    App.prototype.unsubscribeWorkspaceMain = function () {
        var _this = this;
        this.props.dispatch(resetWorkspaceMain());
        Object.keys(this.subscribers).forEach(function (key) {
            if (_this.subscribers[key]) {
                _this.subscribers[key].unsubscribe();
            }
        });
    };
    App.prototype.render = function () {
        if (this.state.isCheckingLogin) {
            return React.createElement(PageLoading, { loadMessage: 'Hiking to the crag...' });
        }
        if (this.props.isAuthenticated && this.state.isFetchingData) {
            return React.createElement(PageLoading, { loadMessage: 'Flipping the guidebook...' });
        }
        return React.createElement(Routes, null);
    };
    return App;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceMain: state.workspaceMain,
    isAuthenticated: state.auth.isSignedIn,
}); };
export default connect(mapStateToProps)(App);



//////////////////
// WEBPACK FOOTER
// ./src/app.tsx
// module id = 607
// module chunks = 0